if (!window.themeReviewReadMoreBound) {
window.themeReviewReadMoreBound = true;

function updateReviewMoreButtons() {
    document.querySelectorAll('[data-review-text]').forEach(function (text) {
    var btn = text.nextElementSibling;
    if (!btn || !btn.hasAttribute('data-review-more')) return;
    if (text.classList.contains('is-expanded') || text.classList.contains('is-animating')) return;
    text.style.maxHeight = '';
    var isClamped = text.scrollHeight > text.clientHeight + 1;
    text.dataset.collapsedHeight = text.clientHeight;
    btn.style.display = isClamped ? 'block' : 'none';
    });
}

function animateHeight(text, from, to, onDone) {
    text.classList.add('is-animating');
    text.style.maxHeight = from + 'px';
    requestAnimationFrame(function () {
    requestAnimationFrame(function () {
        text.style.maxHeight = to + 'px';
    });
    });
    text.addEventListener('transitionend', function onEnd(event) {
    if (event.propertyName !== 'max-height') return;
    text.removeEventListener('transitionend', onEnd);
    text.classList.remove('is-animating');
    onDone();
    });
}

function expandText(text, btn) {
    var collapsedHeight = text.clientHeight;
    var fullHeight;
    text.classList.add('is-animating');
    text.style.maxHeight = collapsedHeight + 'px';
    fullHeight = text.scrollHeight;
    text.classList.remove('is-animating');
    animateHeight(text, collapsedHeight, fullHeight, function () {
    text.classList.add('is-expanded');
    text.style.maxHeight = '';
    });
    btn.textContent = btn.dataset.lessLabel;
}

function collapseText(text, btn) {
    var fullHeight = text.scrollHeight;
    var collapsedHeight = parseInt(text.dataset.collapsedHeight, 10) || 0;
    text.classList.remove('is-expanded');
    animateHeight(text, fullHeight, collapsedHeight, function () {
    text.style.maxHeight = '';
    });
    btn.textContent = btn.dataset.moreLabel;
}

document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-review-more]');
    if (!btn) return;
    var text = btn.previousElementSibling;
    if (!text || !text.hasAttribute('data-review-text')) return;
    if (text.classList.contains('is-animating')) return;
    if (text.classList.contains('is-expanded')) {
    collapseText(text, btn);
    } else {
    expandText(text, btn);
    }
});

function updateCardHeights() {
    document.querySelectorAll('.reviews-gallery .look__container--desktop-slider, .reviews-gallery .look__container--mobile-slider').forEach(function (container) {
    container.style.removeProperty('--card-height');
    var max = 0;
    container.querySelectorAll(':scope > .look__image > .look__image-inner, :scope > .look__video, :scope > .look__featured').forEach(function (card) {
        max = Math.max(max, card.offsetHeight);
    });
    if (max > 0) container.style.setProperty('--card-height', max + 'px');
    });
}

function updateReviewLayout() {
    updateReviewMoreButtons();
    updateCardHeights();
}

window.addEventListener('load', updateReviewLayout);
document.addEventListener('theme:resize', updateReviewLayout);
}